<template>
  <el-dialog
    :visible="visible"
    v-if="visible"
    width="800px"
    top="10vh"
    v-el-dialog-drag
    show-close
    title="客服反馈"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <ServiceFeedbackBatchIndex
      ref="serviceFeedbackBatchIndex"
      :listOrder="listOrder"
      @close="close()"
    />
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button
        type="primary"
        @click="() => $refs.serviceFeedbackBatchIndex.save()"
      >
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ServiceFeedbackBatchIndex from './index'
export default {
  components: { ServiceFeedbackBatchIndex },
  props: {
    listOrder: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
